import { useStats } from '@/hooks/useLocalStorage';
import { Database, User, Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface HeaderProps {
  onMenuToggle: () => void;
}

export function Header({ onMenuToggle }: HeaderProps) {
  const { data: stats } = useStats();

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm h-18 sticky top-0 z-30">
      <div className="px-4 md:px-6 py-4">
        <div className="flex items-center justify-between min-w-0">
          <div className="flex items-center space-x-2 md:space-x-3 min-w-0 flex-1">
            {/* Mobile menu button */}
            <Button
              variant="ghost"
              size="sm"
              className="md:hidden p-1"
              onClick={onMenuToggle}
            >
              <Menu className="h-5 w-5" />
            </Button>
            
            {/* WorkFINITY Logo */}
            <div className="w-8 h-8 md:w-10 md:h-10 bg-workfinity-600 rounded-lg flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold text-xs md:text-sm">W</span>
            </div>
            
            <div className="min-w-0 flex-1">
              <h1 className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 truncate">
                <span className="hidden sm:inline">WorkFINITY® Configuration Management System</span>
                <span className="sm:hidden">Code Manager</span>
              </h1>
              <p className="text-xs md:text-sm text-gray-600 hidden md:block">Code Manager Microservice</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-2 md:space-x-4">
            {/* <div className="hidden sm:flex items-center space-x-2 bg-gray-100 rounded-lg px-3 py-2">
              <Database className="h-4 w-4 text-gray-500" />
              <span className="text-sm text-gray-700">LocalStorage</span>
            </div> */}
            
            <div className="flex items-center space-x-2">
              <div className="w-7 h-7 md:w-8 md:h-8 bg-gray-300 rounded-full flex items-center justify-center">
                <User className="h-3 w-3 md:h-4 md:w-4 text-gray-600" />
              </div>
              <span className="text-sm font-medium text-gray-700 hidden sm:block">Admin</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
